var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import Vue from 'vue';
import { getInstance } from '@bonustrack/lock/plugins/vue';
import { Web3Provider } from '@ethersproject/providers';
import { Contract } from '@ethersproject/contracts';
import { getAddress } from '@ethersproject/address';
import spaces from '@/spaces';
import spacesInfo from '@/spacesInfo';
import spacesImg from '@/spacesImg';
import store from '@/store';
import abi from '@/helpers/abi';
import config from '@/helpers/config';
import providers from '@/helpers/providers';
import { formatUnits } from '@ethersproject/units';
var wsProvider;
var auth;
var web3;
if (wsProvider) {
    wsProvider.on('block', function (blockNumber) {
        store.commit('GET_BLOCK_SUCCESS', blockNumber);
    });
}
var state = {
    account: null,
    name: null,
    balances: {},
    blockNumber: 0,
    spaces: {},
    spacesInfo: {},
    spacesImg: {},
    network: config.networks['1']
};
var mutations = {
    LOGOUT: function (_state) {
        Vue.set(_state, 'account', null);
        Vue.set(_state, 'name', null);
        Vue.set(_state, 'balances', {});
        console.debug('LOGOUT');
    },
    LOAD_PROVIDER_REQUEST: function () {
        console.debug('LOAD_PROVIDER_REQUEST');
    },
    LOAD_PROVIDER_SUCCESS: function (_state, payload) {
        Vue.set(_state, 'account', payload.account);
        Vue.set(_state, 'name', payload.name);
        console.debug('LOAD_PROVIDER_SUCCESS');
    },
    LOAD_PROVIDER_FAILURE: function (_state, payload) {
        Vue.set(_state, 'account', null);
        console.debug('LOAD_PROVIDER_FAILURE', payload);
    },
    HANDLE_CHAIN_CHANGED: function (_state, chainId) {
        providers.setNetwork(chainId);
        Vue.set(_state, 'network', config.networks[chainId]);
        Vue.set(_state, 'spaces', spaces[chainId]);
        Vue.set(_state, 'spacesInfo', spacesInfo[chainId]);
        Vue.set(_state, 'spacesImg', spacesImg);
        console.debug('HANDLE_CHAIN_CHANGED', chainId);
    },
    HANDLE_ACCOUNTS_CHANGED: function (_state, payload) {
        Vue.set(_state, 'account', payload);
        console.debug('HANDLE_ACCOUNTS_CHANGED', payload);
    },
    HANDLE_CLOSE_CHANGED: function () {
        console.debug('HANDLE_CLOSE_CHANGED');
    },
    LOOKUP_ADDRESS_SUCCESS: function () {
        console.debug('LOOKUP_ADDRESS_SUCCESS');
    },
    RESOLVE_NAME_SUCCESS: function () {
        console.debug('RESOLVE_NAME_SUCCESS');
    },
    SEND_TRANSACTION_REQUEST: function () {
        console.debug('SEND_TRANSACTION_REQUEST');
    },
    SEND_TRANSACTION_SUCCESS: function () {
        console.debug('SEND_TRANSACTION_SUCCESS');
    },
    SEND_TRANSACTION_FAILURE: function (_state, payload) {
        console.debug('SEND_TRANSACTION_FAILURE', payload);
    },
    SIGN_MESSAGE_REQUEST: function () {
        console.debug('SIGN_MESSAGE_REQUEST');
    },
    SIGN_MESSAGE_SUCCESS: function () {
        console.debug('SIGN_MESSAGE_SUCCESS');
    },
    SIGN_MESSAGE_FAILURE: function (_state, payload) {
        console.debug('SIGN_MESSAGE_FAILURE', payload);
    },
    GET_BLOCK_REQUEST: function () {
        console.debug('GET_BLOCK_REQUEST');
    },
    GET_BLOCK_SUCCESS: function (_state, payload) {
        Vue.set(_state, 'blockNumber', payload);
        console.debug('GET_BLOCK_SUCCESS', payload);
    },
    GET_BLOCK_FAILURE: function (_state, payload) {
        console.debug('GET_BLOCK_FAILURE', payload);
    }
};
var actions = {
    login: function (_a, connector) {
        var commit = _a.commit, dispatch = _a.dispatch;
        if (connector === void 0) { connector = 'injected'; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        auth = getInstance();
                        return [4 /*yield*/, auth.login(connector)];
                    case 1:
                        _b.sent();
                        if (!auth.provider) return [3 /*break*/, 3];
                        web3 = new Web3Provider(auth.provider);
                        return [4 /*yield*/, dispatch('loadProvider')];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        commit('HANDLE_CHAIN_CHANGED', 1);
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    logout: function (_a) {
        var commit = _a.commit;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                Vue.prototype.$auth.logout();
                commit('LOGOUT');
                return [2 /*return*/];
            });
        });
    },
    loadProvider: function (_a) {
        var commit = _a.commit, dispatch = _a.dispatch;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b, network, accounts, account, name, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        commit('LOAD_PROVIDER_REQUEST');
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        if (auth.provider.removeAllListeners)
                            auth.provider.removeAllListeners();
                        if (auth.provider.on) {
                            auth.provider.on('chainChanged', function (chainId) { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    commit('HANDLE_CHAIN_CHANGED', parseInt(formatUnits(chainId, 0)));
                                    return [2 /*return*/];
                                });
                            }); });
                            auth.provider.on('accountsChanged', function (accounts) { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(accounts.length !== 0)) return [3 /*break*/, 2];
                                            commit('HANDLE_ACCOUNTS_CHANGED', accounts[0]);
                                            return [4 /*yield*/, dispatch('loadProvider')];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2: return [2 /*return*/];
                                    }
                                });
                            }); });
                            auth.provider.on('disconnect', function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    commit('HANDLE_CLOSE');
                                    return [2 /*return*/];
                                });
                            }); });
                        }
                        return [4 /*yield*/, Promise.all([
                                web3.getNetwork(),
                                web3.listAccounts()
                            ])];
                    case 2:
                        _b = _c.sent(), network = _b[0], accounts = _b[1];
                        commit('HANDLE_CHAIN_CHANGED', network.chainId);
                        account = accounts.length > 0 ? accounts[0] : null;
                        return [4 /*yield*/, dispatch('lookupAddress', account)];
                    case 3:
                        name = _c.sent();
                        commit('LOAD_PROVIDER_SUCCESS', {
                            account: account,
                            name: name
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _c.sent();
                        commit('LOAD_PROVIDER_FAILURE', e_1);
                        return [2 /*return*/, Promise.reject()];
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    lookupAddress: function (_a, address) {
        var commit = _a.commit;
        return __awaiter(void 0, void 0, void 0, function () {
            var name, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (state.network.chainId !== 1)
                            return [2 /*return*/];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, providers.rpc.lookupAddress(address)];
                    case 2:
                        name = _b.sent();
                        commit('LOOKUP_ADDRESS_SUCCESS', name);
                        return [2 /*return*/, name];
                    case 3:
                        e_2 = _b.sent();
                        return [2 /*return*/, Promise.reject()];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    resolveName: function (_a, name) {
        var commit = _a.commit;
        return __awaiter(void 0, void 0, void 0, function () {
            var address, e_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (state.network.chainId !== 1)
                            return [2 /*return*/];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, providers.rpc.resolveName(name)];
                    case 2:
                        address = _b.sent();
                        commit('RESOLVE_NAME_SUCCESS', address);
                        return [2 /*return*/, address];
                    case 3:
                        e_3 = _b.sent();
                        return [2 /*return*/, Promise.reject()];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    sendTransaction: function (_a, _b) {
        var commit = _a.commit;
        var contractType = _b[0], contractAddress = _b[1], action = _b[2], params = _b[3];
        return __awaiter(void 0, void 0, void 0, function () {
            var signer, contract, contractWithSigner, overrides, tx, e_4;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        commit('SEND_TRANSACTION_REQUEST');
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        signer = web3.getSigner();
                        contract = new Contract(getAddress(contractAddress), abi[contractType], web3);
                        contractWithSigner = contract.connect(signer);
                        overrides = {};
                        return [4 /*yield*/, contractWithSigner[action].apply(contractWithSigner, __spreadArray(__spreadArray([], params), [overrides]))];
                    case 2:
                        tx = _c.sent();
                        return [4 /*yield*/, tx.wait()];
                    case 3:
                        _c.sent();
                        commit('SEND_TRANSACTION_SUCCESS');
                        return [2 /*return*/, tx];
                    case 4:
                        e_4 = _c.sent();
                        commit('SEND_TRANSACTION_FAILURE', e_4);
                        return [2 /*return*/, Promise.reject()];
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    signMessage: function (_a, message) {
        var commit = _a.commit;
        return __awaiter(void 0, void 0, void 0, function () {
            var signer, sig, e_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('SIGN_MESSAGE_REQUEST');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        signer = web3.getSigner();
                        return [4 /*yield*/, signer.signMessage(message)];
                    case 2:
                        sig = _b.sent();
                        commit('SIGN_MESSAGE_SUCCESS');
                        return [2 /*return*/, sig];
                    case 3:
                        e_5 = _b.sent();
                        commit('SIGN_MESSAGE_FAILURE', e_5);
                        return [2 /*return*/, Promise.reject(e_5)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    getBlockNumber: function (_a) {
        var commit = _a.commit;
        return __awaiter(void 0, void 0, void 0, function () {
            var blockNumber, e_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commit('GET_BLOCK_REQUEST');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, providers.rpc.getBlockNumber()];
                    case 2:
                        blockNumber = _b.sent();
                        commit('GET_BLOCK_SUCCESS', parseInt(blockNumber));
                        return [2 /*return*/, blockNumber];
                    case 3:
                        e_6 = _b.sent();
                        commit('GET_BLOCK_FAILURE', e_6);
                        return [2 /*return*/, Promise.reject()];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
};
export default {
    state: state,
    mutations: mutations,
    actions: actions
};
